<template>
  <Popup v-model="showPop" position="bottom">
    <div class="auth-result-popup">
      <div class="auth-result-popup__close" @click="closePopup"><img src="@/assets/img/close.png" alt=""></div>

      <!-- SUCCESS -->
      <template v-if="verifyResult === 'SUCCESS'">
        <div class="auth-result-popup__title">{{ title }}</div>
        <div class="auth-result-popup__img">
          <img src="@/assets/img/u56.svg" alt="">
          <img src="@/assets/img/u82.svg" alt="" class="img-overlay">
          <img src="@/assets/img/u83.svg" alt="" class="img-overlay2">
        </div>
        <div class="auth-result-popup__success-text">{{ $t('kycPop.authResultSuccess') }}</div>
        <br/>
        <br/>
        <br/>
        <br/>
        <div class="auth-result-popup__countdown" v-if="autoContinue && countdown > 0">{{ $t('kycPop.redirecting') }} ({{ countdown }}s)</div>
        <div class="auth-result-popup__footer">
          <div class="btn-primary" @click="handleContinue">{{ successButtonText || $t('kycPop.continueToPayment') }}</div>
        </div>
      </template>

      <!-- CAN_RETRY -->
      <template v-else-if="verifyResult === 'CAN_RETRY'">
        <div class="auth-result-popup__title">{{ title }}</div>
        <div class="auth-result-popup__img">
          <img src="@/assets/img/u102.svg" alt="">
        </div>
        <div class="auth-result-popup__desc" v-if="authType==='ocr'">{{ $t('kycPop.authResultOcrFailDesc1') }}</div>
        <div class="auth-result-popup__desc" v-if="authType==='face'">{{ $t('kycPop.authResultRetryDesc') }}</div>
        <br/>
        <br/>
        <br/>
        <br/>
        <div class="auth-result-popup__footer">
          <div class="btn-primary" @click="handleRetry">{{ $t('kycPop.startVerification') }}</div>
        </div>
      </template>

      <!-- FAIL -->
      <template v-else-if="verifyResult === 'FAIL'">
        <div class="auth-result-popup__title">{{ title }}</div>
        <div class="auth-result-popup__img">
          <img src="@/assets/img/u119.svg" alt="">
        </div>
        <div class="auth-result-popup__fail-text">{{ title }}{{ $t('kycPop.authResultFailTitle') }}</div>
        <br/>
        <div class="auth-result-popup__fail-desc" v-if="authType==='ocr'">{{ $t('kycPop.authResultOcrFailDesc1') }}</div>
        <div class="auth-result-popup__fail-desc">{{ $t('kycPop.authResultFailDesc1') }}</div>
        <div class="auth-result-popup__fail-desc">{{ $t('kycPop.authResultFailDesc2') }}</div>
        <div class="auth-result-popup__footer">
          <div class="btn-primary" @click="handleBack">{{ $t('kycPop.authResultBack') }}</div>
        </div>
      </template>
    </div>
  </Popup>
</template>

<script>
import { Popup } from 'vant';
export default {
  name: 'AuthResultPopup',
  components: {
    Popup
  },
  props: {
    autoContinue: {
      type: Boolean,
      default: true
    },
    successButtonText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showPop: false,
      authType: '',
      verifyResult: '',
      countdown: 5,
      timer: null
    }
  },
  computed: {
    title() {
      return this.authType === 'ocr' ? this.$t('kycPop.identityVerify') : this.$t('kycPop.faceVerify');
    }
  },
  methods: {
    open({ authType, verifyResult }) {
      this.authType = authType;
      this.verifyResult = verifyResult;
      this.showPop = true;

      if (verifyResult === 'SUCCESS' && this.autoContinue) {
        this.countdown = 5;
        this.startCountdown();
      }
    },
    closePopup() {
      this.showPop = false;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.$emit('close');
    },
    startCountdown() {
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.handleContinue();
        }
      }, 1000);
    },
    handleContinue() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.showPop = false;
      this.$emit('success');
    },
    handleRetry() {
      this.showPop = false;
      this.$emit('retry');
    },
    handleBack() {
      this.showPop = false;
      this.$emit('back');
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style lang="less">
.auth-result-popup {
  padding: 40px 30px 50px;
  width: 750px;
  background: #FFFFFF;
  border-radius: 50px 50px 0px 0px;
  position: relative;

  &__close {
    position: absolute;
    right: 22px;
    top: 28px;
    width: 40px;
    height: 40px;

    img {
      margin: 8px auto;
      display: block;
      width: 24px;
      height: 24px;
    }
  }

  &__title {
    font-size: 36px;
    font-weight: 600;
    line-height: 50px;
    color: var(--text-color-black);
    text-align: left;
  }

  &__img {
    position: relative;
    width: 250px;
    height: 250px;
    margin: 40px auto 0;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    .img-overlay {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 100%;
      max-height: 100%;
    }

    .img-overlay2 {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__success-text {
    margin-top: 30px;
    font-size: 32px;
    font-weight: 600;
    line-height: 44px;
    color: var(--primary-color);
    text-align: center;
  }

  &__countdown {
    margin-top: 16px;
    font-size: 26px;
    line-height: 36px;
    color: var(--text-color-gray);
    text-align: center;
  }

  &__desc {
    margin-top: 30px;
    font-size: 26px;
    line-height: 38px;
    color: var(--text-color-gray);
    text-align: center;
  }

  &__fail-text {
    margin-top: 30px;
    font-size: 26px;
    line-height: 38px;
    color: var(--text-color-gray);
    text-align: center;
  }

  &__fail-desc {
    margin-top: 16px;
    font-size: 26px;
    line-height: 36px;
    color: var(--text-color-gray);
    text-align: center;
  }

  &__footer {
    margin-top: 40px;
  }
}
</style>
